import { render, staticRenderFns } from "./RestaurantProfileComponent.vue?vue&type=template&id=2aaa80cc&scoped=true"
import script from "./RestaurantProfileComponent.vue?vue&type=script&lang=js"
export * from "./RestaurantProfileComponent.vue?vue&type=script&lang=js"
import style0 from "./RestaurantProfileComponent.vue?vue&type=style&index=0&id=2aaa80cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaa80cc",
  null
  
)

export default component.exports